import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import '@/global.js';
// -v 项目
import createApp from '@/global.js';
import App from '@/pages/index/index.vue';
import { reportStaticResourcePerf } from '/opt/meituan/jenkins/slave/workspace/22317954-better-oversea-grocery-osg-fe-jiemo-pc-v-app_38567-production/node_modules/.pnpm/@osgfe+web-tracer@2.8.12/node_modules/@osgfe/web-tracer/lib/main.cjs'

window.__tracer.startTXN('ob_framework_mount');

/**
* 此文件由 OSG Vue2 Preset 自动生成，请勿手动修改
*/
window.Vue = Vue;
if (window.$xxEE) {
  try {
    window.$xxEE.emit('app:before-render');
  } catch(err) {
    console.error('Event hook error [app:before-render]:', err);
  }
}
createApp(App);
if (window.$xxEE) {
  try {
    window.$xxEE.emit('app:after-render');
  } catch(err) {
    console.error('Event hook error [app:after-render]:', err);
  }
}


window.__tracer.endTXN('ob_framework_mount'); reportStaticResourcePerf(); window.__tracer.forceFlush();